import "bootstrap/dist/css/bootstrap.min.css";
import MainPage from "./pages/MainPage";
import "./styles/bootstrap.min.css";

function App() {
  return (
    <MainPage />
  )
}

export default App;
